module.exports = __webpack_public_path__ + "img/sankaku_27_red.ff508d53.png";